(() => {
  const template = document.currentScript?.dataset.akwayaTierCopy;
  if (!template || !template.includes('__AMOUNT__')) return;
  const observed = new WeakSet();
  function connect() {
    document.querySelectorAll('[data-akwaya-rewards-root] [data-akwaya-tier-progress-wrap]').forEach((wrap) => {
      if (observed.has(wrap)) return;
      const text = wrap.querySelector('[data-akwaya-tier-progress-text]');
      if (!text) return;
      observed.add(wrap);
      const correct = () => {
        const match = text.textContent.trim().match(/^([\d\s,.\u00a0\u202f]+) points to next tier$/);
        if (!match) return;
        text.textContent = template.replace('__AMOUNT__', `$${match[1].trim()}`) + ' ';
        wrap.classList.add('akwaya-tier-copy-corrected');
      };
      new MutationObserver(correct).observe(text, { childList: true, characterData: true, subtree: true });
      correct();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
})();

(() => {
  const rewardsPath = '/pages/01a0c71c-3342-7449-9ee1-a8461426a11e';
  function connect() {
    document.querySelectorAll('[data-akwaya-rewards-root]').forEach((root) => {
      if (!root.dataset.rewardsUrl) return;
      let previous;
      try {
        previous = new URL(root.dataset.rewardsUrl, window.location.origin);
      } catch {
        return;
      }
      if (previous.origin !== 'https://account.akwaya.com' || previous.pathname !== '/profile') return;
      const destination = new URL(previous.href);
      destination.pathname = rewardsPath;
      root.querySelectorAll('a[href]').forEach((link) => {
        if (link.href === previous.href) link.href = destination.href;
      });
      root.dataset.rewardsUrl = destination.href;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
})();
